import React, { useState, useRef, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import AOS from 'aos'
import Icon from '../../../../components/icons'
import Text from '../../../../elements/Typo/Text'
import ShareExperimentModal from '../../../../components/modal/ShareExperiment.modal'
import toast from 'react-hot-toast'
import { ExperimentDetailsI, SharedUserResponseI, SharedUsersI } from '../../../../_config/types'
import { useExperimentApi } from '../../../../store/api/hooks/experimentApiHook'
import { ErrorResponse, SuccessApiResponse } from '../../../../store/api/apiTypes'
import { getShortUserName, trackEvent } from '../../../../_common/functions'

interface Props {
    experiment: ExperimentDetailsI
    reportError?: (x: boolean) => void
}
const SharedWith: React.FC<Props> = ({ experiment, reportError }) => {
    const { t } = useTranslation()
    const { getSharedUsers } = useExperimentApi()
    const experimentShareModal: any = useRef()

    const [sharedUserList, setSharedUserList] = useState<SharedUsersI[]>([])

    const _handleShowShareDetails = () => {
        trackEvent('experiment_details_shared_with_opened', { experiment_literal: experiment?.experiment_literal })
        trackEvent('share_experiment_modal_opened', { experiment_literal: experiment?.experiment_literal, source: 'details_header' })
        experimentShareModal.current?.showModal()
    }

    const _handleFetchShareUsers = () => {
        getSharedUsers(
            {
                literal: experiment.experiment_literal,
                sort_by: '-shared_at',
                page: 1,
                per_page: 3,
            },
            (resp: SuccessApiResponse<SharedUserResponseI>) => {
                setSharedUserList(resp.data.data)
            },
            (error: ErrorResponse<SharedUserResponseI>) => {
                if (reportError) {
                    reportError(true)
                }
                toast.error(error.message)
            },
        )
    }

    useEffect(() => {
        if (experiment?.experiment_literal) {
            _handleFetchShareUsers()
        }
    }, [experiment])

    useEffect(() => {
        AOS.init({
            once: false, // Animation occurs every time you scroll to the element
        })
        AOS.refresh()
    }, [])

    return (
        <div className="" data-aos="zoom-in" data-aos-delay="200">
            {/* <div className="flex bg-[#F1F1F1] rounded-[1.667rem] items-center"> */}
            <button type="button" data-testid="share-button" onClick={_handleShowShareDetails} className="bg-[#F1F1F1] flex gap-[0.33rem] items-center rounded-[1.045rem]">
                <div className="h-[1.182rem] w-[1.182rem] rounded-[1.045rem] bg-primary flex items-center justify-center">
                    <Icon name="share-alt" size={'0.545rem'} color="black"></Icon>
                </div>

                <Text size="xs" className="!text-[0.591rem] !font-semibold pl-1 whitespace-nowrap">
                    {t('Shared with')}
                </Text>

                <div className="flex pl-1 pr-[0.4rem]">
                    {sharedUserList.slice(0, 3).map((user: SharedUsersI, index: number) => (
                        <div className="w-[0.7rem]" key={user.first_name + index}>
                            <div className="h-[1.083rem] w-[1.083rem] rounded-full bg-primary flex items-center justify-center border border-white">
                                <span className="font-bold text-[0.417rem] leading-none">{getShortUserName(user.first_name, user.last_name)}</span>
                            </div>
                        </div>
                    ))}
                </div>
            </button>
            {/* </div> */}

            {experiment?.experiment_literal && <ShareExperimentModal _ref={experimentShareModal} experiment={experiment} updateSharedUserList={setSharedUserList} />}
        </div>
    )
}
export default SharedWith
